import React, { Fragment } from "react";
import { useFormikContext } from "formik";
import { STATE_KEYS } from "utils/constants/state";
import get from "lodash/get";
import { CLUSIVITY_OPTIONS } from "utils/constants/feature";
import OptionListPicker from "components/OptionListPicker";
import ConnectedField from "components/ConnectedField";
import OrderSettings from "../OrderSettings";
import { resetProductFeatureLayouts } from "utils/feature";
import { integerTransformer } from "utils/form";
import Button from "components/Form/fields/Button";
import {
  BUTTON_CLASS_CONTEXT,
  BUTTON_TAGS,
  secondaryBackButton
} from "utils/constants/ui";
import { SECTIONS } from "components/FormerEditor/utils";
import MenuNavHeader from "components/MenuNavHeader";
import Toggle from "react-toggle";
import { getToggleProps } from "utils/form";
import { useAppManifestSectionDestination } from "utils/hooks";

const FeatureListHub = ({ name }) => {
  const { values, setFieldValue, setFieldTouched } = useFormikContext();
  const goBack = () => {
    setFieldValue(STATE_KEYS.EDITOR.PRICING_INTENT, null);
    setFieldValue(STATE_KEYS.EDITOR.PRICING_ACTIVE_PRICE, null);
  };

  const featuresDestination = useAppManifestSectionDestination(
    SECTIONS.FEATURES
  );
  const buttonProps = secondaryBackButton({ onClick: () => goBack() });

  const clusivityProps = {
    label: "List style",
    value: get(values, STATE_KEYS.MANIFEST.FEATURES_CLUSIVITY),
    name: STATE_KEYS.MANIFEST.FEATURES_CLUSIVITY,
    options: CLUSIVITY_OPTIONS,
    beforeClick: () => {
      const featuresConfig = get(values, STATE_KEYS.MANIFEST.FEATURES);
      const updatedFeatureConfig = resetProductFeatureLayouts(featuresConfig);
      setFieldValue(STATE_KEYS.MANIFEST.FEATURES, updatedFeatureConfig);
    }
  };

  return (
    <Fragment>
      <MenuNavHeader navSetters={[buttonProps]} label="Top features">
        <Toggle
          {...getToggleProps({
            active: get(values, STATE_KEYS.MANIFEST.FEATURES_SHOW),
            setFieldValue: (_, active) => {
              setFieldValue(STATE_KEYS.MANIFEST.FEATURES_SHOW, active);
              setFieldTouched(STATE_KEYS.MANIFEST.FEATURES_SHOW, true);
            }
          })}
        />
      </MenuNavHeader>
      <div className="pt3">
        <div className="f4 ph3 pb3 fw6">Features</div>
        <div className="f6 ph3 pb3 lh-copy">
          Update your features for each product within the feature comparison
          group builder.
        </div>
        <div className="ph3 pb3">
          <Button
            theme="slim"
            tag={BUTTON_TAGS.LINK}
            href={featuresDestination}
            classes={{
              contextClass: BUTTON_CLASS_CONTEXT.SECONDARY
            }}
            copy="Set features"
          />
        </div>
      </div>
      <div className="pt3">
        <div className="flex flex-row justify-between ph3 pb3">
          <div className="f4 fw6">Presentation</div>
        </div>
        <div className="f7 lh-title pa3 bg-content--secondary bb bt hairline-1 bh--inset">
          Note: Changing presentation type will unset all custom ordering.
        </div>
        <div className="pt3">
          <OptionListPicker {...clusivityProps} />
        </div>
      </div>
      <div
        key="top-feature-limit"
        className="pv3 flex flex-row justify-between items-start ph3 bb hairline-1"
      >
        <div className="flex flex-column">
          <div className="f5 fw5 flex">Max</div>
          <div className="f6 flex pt2 lh-copy">
            Control the max number of top features that show.
          </div>
        </div>
        <div className="flex pl2" style={{ width: 100 }}>
          <ConnectedField
            name={STATE_KEYS.MANIFEST.FEATURES_LIMIT}
            transformer={(fieldVal) => integerTransformer(fieldVal, "")}
          />
        </div>
      </div>
      <div className="pt4">
        <OrderSettings name={name} />
      </div>
    </Fragment>
  );
};

export default FeatureListHub;
